// import { lazy } from "react";
import React, { useEffect, useState } from "react";
import { Typography, Grid, Button, styled, Box } from "@mui/material";
import { Divider, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import HomeIcon from "@mui/icons-material/Home";
import { hasPermission } from "../../service/authService";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#09829d",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "1rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

const PaperCard = (props: any) => {
  return (
    <Paper
      sx={{
        boxShadow: "0 3px 5px 2px rgba(0, 0, 0, .3)",
        position: "relative",
        borderRadius: 2,
        padding: 2,
        width: "90%", // Take full width of Grid item
        maxWidth: 360, // Restrict max width
        mx: "auto", // Center horizontally
      }}
    >
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography variant="h5">
            <strong>{props.title}</strong>
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {props.caption}
          </Typography>
        </Grid>

        <Divider sx={{ my: 1, borderColor: "#FF825B" }} />

        <Grid item>
          <Box display="flex" justifyContent="flex-start">
            <MyCustomButton
              type="button"
              variant="contained"
              size="medium"
              endIcon={<ArrowCircleRightIcon />}
              onClick={props.onClick}
              disabled={props.disabled || false}
            >
              <strong>{"Proceed"}</strong>
            </MyCustomButton>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

const ExamsManagementHome: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Grid container spacing={2} justifyContent="center" mb={1}>
      <Box width="100%" px={{ xs: 2, sm: 4 }} mt={1}>
        <Typography
          variant="h4"
          textAlign="center"
          sx={{
            color: "#2E186A",
            mt: 2,
            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
          }}
        >
          <strong>Exams Management Home</strong>
        </Typography>

        <Box
          display="flex"
          justifyContent={{ xs: "center", sm: "flex-start" }}
          mt={2}
        >
          <MyCustomButton
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/home")}
          >
            Back
          </MyCustomButton>
        </Box>

        {hasPermission("Exams Management") && (
          <Grid
            container
            spacing={2}
            mt={2}
            justifyContent="center"
            alignItems="flex-start"
            sx={{ px: { xs: 2, sm: 4 } }}
          >
            {hasPermission("Create New Exams") && (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                display="flex"
                justifyContent="center"
              >
                <PaperCard
                  title="Create New Exams"
                  caption="Create New Exams. One Time Setup Only"
                  onClick={() => navigate("add-exams")}
                />
              </Grid>
            )}

            {hasPermission("Schedule An Exam") && (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                display="flex"
                justifyContent="center"
              >
                <PaperCard
                  title="Exam Schedules"
                  caption="View and Schedule Exams. Update Max Marks For Subjects."
                  onClick={() => navigate("schedule-exam")}
                />
              </Grid>
            )}

            {hasPermission("Admit Cards") && (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                display="flex"
                justifyContent="center"
              >
                <PaperCard
                  title="Admit Cards"
                  caption="Fetch and Print Admit Card For Selected Class And Section"
                  onClick={() => navigate("get-admit-card")}
                />
              </Grid>
            )}

            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              display="flex"
              justifyContent="center"
            >
              <PaperCard
                title="Report Cards"
                caption="Update Marks, Attendance, Print Report Card"
                onClick={() => navigate("manage-marks")}
              />
            </Grid>

            {hasPermission("Promote Students") && (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                display="flex"
                justifyContent="center"
              >
                <PaperCard
                  title="Promote Students"
                  caption="Promote Students To Higher Class"
                  onClick={() => navigate("generate-report-card")}
                  disabled
                />
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </Grid>
  );
};

export default ExamsManagementHome;
